import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";
import {
  SET_NAV_ACTIVE_ITEM,
  CLEAR_NAV_ACTIVE_ITEM,
  UPDATE_NAVIGATION_TREE,
  SET_NAV_API_REFRESHED_WITH_NAV_API_DATA
} from "./constants";

export { PRIMARY, SECONDARY } from "./constants";

const navigationShape = {
  id: PropTypes.string.isRequired,
  alias: PropTypes.string,
  label: PropTypes.string,
  linkType: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  excludes: PropTypes.array.isRequired,
  largeScreenPriority: PropTypes.number,
  smallAndMediumImageUrl: PropTypes.string
};

export const navigationItemPropType = PropTypes.shape(navigationShape);

export const navigationPropType = PropTypes.shape({
  ...navigationShape,
  items: PropTypes.arrayOf(navigationItemPropType).isRequired
});

export {
  setNavActiveItem,
  clearNavActiveItem,
  updateNavigationTree,
  setNavRefreshedWithNavApiData
} from "./actions";
export { UL_ITEM_COUNT } from "./constants";
export {
  femaleLargePrimaryNavigationItems,
  femaleSidePrimaryNavigationItems,
  maleLargePrimaryNavigationItems,
  maleSidePrimaryNavigationItems,
  primaryNavigationItems,
  footerNavigation,
  getNavActiveItem,
  getIsNavApiLoaded
} from "./selectors";

const initialState = {};

export const reduce = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NAV_ACTIVE_ITEM:
      return {
        ...state,
        activeNavItem: payload
      };

    case CLEAR_NAV_ACTIVE_ITEM:
      return {
        ...state,
        activeNavItem: null
      };

    case UPDATE_NAVIGATION_TREE: {
      const nextFooter = payload.footer || state.footer;

      const treeUnchanged = isEqual(state.tree, payload.tree);
      const footerUnchanged = isEqual(state.footer, nextFooter);

      if (treeUnchanged && footerUnchanged) {
        return state;
      }

      return {
        ...state,
        tree: treeUnchanged ? state.tree : payload.tree,
        footer: footerUnchanged ? state.footer : nextFooter
      };
    }

    case SET_NAV_API_REFRESHED_WITH_NAV_API_DATA:
      if (state.isNavApiLoaded) {
        return state;
      }

      return {
        ...state,
        isNavApiLoaded: true
      };
  }

  return state;
};
